import * as Sentry from '@sentry/react';

const onError: Sentry.ErrorBoundaryProps['onError'] = function onError(
  _error,
  _componentStack,
  _eventId,
) {
  // console.info(componentStack);
  // console.error(error);
};

export function ErrorBoundary(props: Sentry.ErrorBoundaryProps) {
  return <Sentry.ErrorBoundary onError={onError} {...props} />;
}
